export default {
  task: {},
  tasks: [],
  taskLists: [],
};
